import { helper } from '@ember/component/helper';

export default helper(function thumbLetter(positional /*, named*/) {
  var firstLetter = '';

  if (typeof positional[0] === 'string') {
    firstLetter += positional[0].charAt(0).toLowerCase();
  }
  return firstLetter;
});
